import { Component, Input } from '@angular/core';

@Component({
  selector: 'card-item',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})

export class CardComponent {
  @Input() direction: 'left' | 'right';
  @Input() title: string;
  @Input() img: string;
}
